import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../../../index.css';
import Slider from 'react-slick';

class DiscoverServices extends Component{
    constructor() {
        super();
    }
    render(){
        return(
            <section className="discover">
                <h2>Our Services</h2>
                <div className="row">
                    <Link to="/services/front-end" className="col-1">
                        <div className="col-1">
                            <div className="badge fe-badge">FD</div>
                            <h3>Frontend Development</h3>
                        </div>
                    </Link>
                    <Link to="/services/back-end" className="col-1">
                        <div className="col-1">
                            <div className="badge be-badge">BE</div>
                            <h3>Backend Development</h3>
                        </div>
                    </Link>
                    <Link to="/services/mobile" className="col-1">
                        <div className="col-1">
                            <div className="badge mo-badge">MO</div>
                            <h3>Mobile Development</h3>
                        </div>
                    </Link>
                    <Link to="/services/microsoft" className="col-1">
                        <div className="col-1">
                            <div className="badge md-badge">MD</div>
                            <h3>Microsoft Development</h3>
                        </div>
                    </Link>
                    <Link to="/services/database" className="col-1">
                        <div className="col-1">
                            <div className="badge dm-badge">DM</div>
                            <h3>Database Management</h3>
                        </div>
                    </Link>
                    <Link to="/services/devops" className="col-1">
                        <div className="col-1">
                            <div className="badge do-badge">DO</div>
                            <h3>DevOps</h3>
                        </div>
                    </Link>
                </div>
            </section>
        )
    }
}

export default DiscoverServices;



// WEBPACK FOOTER //
// ./src/components/homepage/views/discoverServices.js